import React, { useState, useContext } from 'react'
import Textarea from 'components/Textarea'
import { components } from 'react-select'
import { FormattedMessage } from 'react-intl'
import Select from 'components/Select'
import proposalCategories from 'constants/proposalCategories'
import Button from 'components/Button'
import BoldComment from 'assets/icons/bold-comment'
import HighlightComment from 'assets/icons/highlight-comment'
import AssigmentComment from 'assets/icons/assigment-comment'
import LeaveComment from 'assets/icons/leave-comment'
import { requestAddCommentData } from 'api/site'
import { SiteContext } from 'providers/site'
import { useParams } from 'react-router-dom'

import {
  ManageUsersLabel,
  ManageCategoryLabel,
  ManageUsersSeparator,
  CommentArea,
  CommentButtonsLeft,
  CommentButtonsRight,
  LeaveCommentBg,
  TextAreaControls
} from './style'
import { editOnly } from 'routing/constants'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'

const formattedCategories = [{ value: null, label: 'All categories' }, ...proposalCategories.map((item) => {
  return {
    value: item.id,
    label: item.name
  }
})]


const ManageCategorySelectPlaceholder = (placeholderId, placeholderCategory) => {
  return function Placeholder(props) {
    return (
      <components.Placeholder {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ManageUsersSeparator />
          <ManageUsersLabel>
            <FormattedMessage id={placeholderId} />
          </ManageUsersLabel>
          <ManageCategoryLabel>
            <FormattedMessage id={placeholderCategory} />
          </ManageCategoryLabel>
        </div>
      </components.Placeholder>
    )
  }
}

const CommentForm = ({ getCommentsData, changeCategory, categorySelected, setCategorySelected }) => {
  const params = useParams()
  const { site } = useContext(SiteContext)
  const [commentsTextArea, setCommentsTextArea] = useState('')
  const [height, setHeight] = useState('186px')
  const [isExpanded, setIsExpanded] = useState(true)

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;
  const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  const historyId = editOnlySiteStatus ? site.sitehistoryId : params.siteHistoryId

  const onCommentsChange = (e) => {
    setCommentsTextArea(e.target.value)
  }

  const handleCategoryChange = (e) => {
    setCategorySelected(e)
    changeCategory(e.value)
  }

  const handleExpandChange = () => {
    setIsExpanded(true)
    setHeight('186px')
  }

  const handleCancelExpandChange = () => {
    setCommentsTextArea('')
    setIsExpanded(false)
    setHeight('25px')
  }

  const submitComment = async (event) => {
    event.preventDefault();
    if (!commentsTextArea) {
      return;
    }

    const commentData = {
      content: commentsTextArea,
      CategoryId: categorySelected.value
    };

    try {
      await requestAddCommentData(site.id, historyId, commentData, editOnlySite);
      await getCommentsData();
      setCommentsTextArea('');
    } catch (error) {
      throw error;
    }
  };

  return (
    <div style={{ padding: '8px 8px 0 8px' }}>
      <Select
        placeholderComponent={ManageCategorySelectPlaceholder(
          'categoryDropdownPlaceholder',
          categorySelected.label
        )}
        field="categoryDropdown"
        value={null}
        options={formattedCategories}
        onChange={handleCategoryChange}
        height="48px"
        placeholder="categoryDropdownPlaceholder"
        menuPlacement="bottom"
        menuWidth="50%"
        border="none"
        marginBottom="16px"
      />
      <CommentArea>
        <Textarea
          value={commentsTextArea}
          field='commentsTextArea'
          onChange={onCommentsChange}
          onClick={handleExpandChange}
          placeholder="commentsPlaceholder"
          height={height}
          dataTest='comments-text-area'
          resize="none"
          border="none"
          boxShadow="none"
          marginBottom={isExpanded ? "" : "0"}
          disabled={categorySelected.value === null}
          background={!isExpanded ? "rgb(244 244 244)" : "#ffffff"}
        />
        {isExpanded && <TextAreaControls>
          <CommentButtonsLeft>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <BoldComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <HighlightComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <AssigmentComment />
            </Button>
          </CommentButtonsLeft>
          <CommentButtonsRight>
            <Button marginTop="0" type="cancelComments" onClick={handleCancelExpandChange}>
              <FormattedMessage id="cancel" />
            </Button>
            <div style={{ alignSelf: 'center' }}>
              <LeaveCommentBg enable={commentsTextArea} disabled={true} onClick={submitComment}>
                <LeaveComment />
              </LeaveCommentBg>
            </div>
          </CommentButtonsRight>
        </TextAreaControls>}
      </CommentArea>
      <div style={{ border: 'none' }}>
      </div>
    </div>
  )
}

export default CommentForm
